import { postUploadSource } from "@/apis/cs-rag/route";
import { csRagQueries } from "@/queries";
import { Button } from "@/toggle-ui-kit/button";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Upload } from "lucide-react";
import { useRef, useState } from "react";

const ACCEPT = ".pdf,.xlsx,.html,.htm,.zip";

export const FileUploader: React.FC = () => {
  const queryClient = useQueryClient();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [statusMessage, setStatusMessage] = useState(
    "PDF, xlsx, HTML, ZIP(Notion export 등) 지원",
  );

  const uploadMutation = useMutation({
    mutationFn: (file: File) => postUploadSource(file),
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: csRagQueries.sources().queryKey,
      });
      setStatusMessage(`완료: ${data.title} (${data.page_count} 페이지/시트)`);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    },
    onError: (error) => {
      const message =
        error instanceof Error ? error.message : "업로드에 실패했습니다";
      setStatusMessage(`실패: ${message}`);
    },
  });

  const handleUpload = () => {
    const file = fileInputRef.current?.files?.[0];
    if (!file) {
      setStatusMessage("파일을 선택해주세요");
      return;
    }
    setStatusMessage("업로드 및 인덱싱 중… (파일 크기에 따라 수십 초~수 분)");
    uploadMutation.mutate(file);
  };

  return (
    <div className="rounded-xl border-2 border-dashed border-line-alternative bg-white p-7 text-center">
      <div className="flex items-center justify-center gap-3">
        <input
          ref={fileInputRef}
          type="file"
          accept={ACCEPT}
          className="body-2-normal-regular text-label-normal"
          disabled={uploadMutation.isPending}
        />
        <Button
          variant="solid"
          color="secondary"
          size={36}
          onClick={handleUpload}
          disabled={uploadMutation.isPending}
          leftIcon={<Upload className="size-4" />}
        >
          업로드
        </Button>
      </div>
      <p className="mt-3 caption-1-regular text-label-assistive">
        {statusMessage}
      </p>
    </div>
  );
};
